import axios from '@/utils/request'
import utils from '../utils'
var Qs = require('qs')

export default {

	// 2021-02-07
	search(params) {
		return axios.get('/mms/returned-materials?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-02-07
	findBySerialNo(params) {
		return axios.get('/mms/returned-materials/find-by-serial-no', params);
	},
	// 2021-02-07
	create(params) {
		return axios.post('/mms/returned-materials', params)
	},
	// 2021-02-07
	delete(id) {
		return axios.delete('/mms/returned-materials/' + id)
	},
	// 2021-02-07
	update(id, params) {
		return axios.put('/mms/returned-materials/' + id, params)
	},
	// 2021-02-07
	verify(id) {
		return axios.put('/mms/returned-materials/' + id + '/verify', id)
	},
	// 2021-02-07
	finish(id) {
		return axios.put('/mms/returned-materials/' + id + '/finish')
	},
	// 2021-02-07
	findItems(id) {
		return axios.get('/mms/returned-materials/' + id + '/items')
	},
	// 2021-02-07
	updateItem(id, itemId, params) {
		return axios.put('/mms/returned-materials/' + id + '/items/' + itemId, params)
	},
	// 2021-02-07
	deleteItem(id, itemId) {
		return axios.delete('/mms/returned-materials/' + id + '/items/' + itemId)
	},
	// 2021-02-07
	addItem(id, params) {
		return axios.post('/mms/returned-materials/' + id + '/items', params)
	},
	//2021-02-07
	exportExcel(params) {
		return axios.get('/mms/returned-materials/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-02-07
	findById(id) {
		return axios.get('/mms/returned-materials/' + id)
	}
}

